import { useState } from 'react'
import { RealLocationInput } from './LocationInputTwo'
import SmallLocationInput from './SmallLocationInput'
import { useAppState } from '@src/state'

type LocationInputProps = {
  small?: boolean
  label?: string
  placeholder?: string
  icon?: boolean
  errorText?: string
  value?: any
  disabled?: boolean
  height?: number
  nav?: boolean
  inline?: boolean
  loading?: boolean
  style?: any
  defaultValue?: {
    formatted_address?: string
  }
  handleChange?: (input: any) => any
}

export default function LocationInput({
  nav,
  home,
  small,
  clear,
  markRequired,
  label,
  placeholder,
  errorText,
  handleChange,
  defaultValue,
  style,
  disabled,
}) {

  const { state, dispatch } = useAppState()

  if (small) {
    return (
      <>
        <SmallLocationInput
          clear={clear}
          errorText={errorText}
          label={label}
          style={style}
          disabled={disabled}
          handleUpdate={handleChange}
          defaultValue={defaultValue}
          placeholder={placeholder}
          scriptLoaded={state?.locationScriptLoaded}
        />
      </>
    )
  } else if (!small) {
    return (
      <>
        <RealLocationInput
          home={home}
          style={style}
          handleUpdate={handleChange}
          defaultValue={defaultValue}
          scriptLoaded={true}
          markRequired={markRequired}
        />
      </>
    )
  }
}
